export default __webpack_public_path__ + "static/media/who-we-are-banner.12003c3f.jpg";